import colors from "../../../../appConfig/colors";
import { makeStyles } from "@material-ui/core/styles";

const DeleteAssessmentPopoverStyle = makeStyles((theme) => ({
	dialogTitle: {
		background: colors.primary,
		color: colors.white,
	},
	actionButtonContainer: {
		marginLeft: 15,
		marginRight: 15,
		marginBottom: 8,
	},
	cancelButton: {
		color: colors.charcoalGray,
		textTransform: "none",
		width: "100px",
		backgroundColor: `${colors.nearWhite} !important`,
		"&:hover": {
			backgroundColor: `${colors.warmOffWhite} !important`,
		},
	},
	deleteButton: {
		color: colors.white,
		background: `${colors.primary} !important`,
		textTransform: "none",
		width: "100px",
		"&:hover": {
			backgroundColor: `${colors.darkCrimsonRed} !important`,
		},
	},
	progressIcon: {
		color: colors.white,
	},
}));

export default DeleteAssessmentPopoverStyle;
